<!-- <app-header #header></app-header>
<app-breadcrumb></app-breadcrumb> -->

<link rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0" />
<div class="main">

  <div class="row m-0 imp">

    <div class="user-details col-12 col-md-4 lg-12 px-0 p-3 pl-2">

      <div class="userinfodiv">
        <div class="user-photo">
          <div class="photo">
            <img width="100%" height="100%" src="../../../assets/images/user_avtar.png" />
          </div>
        </div>
        <div class="user-info py-2">
          <div class="name">
            <div class="nameicon d-flex">
              <span class="h5 fw-600 emp-name">{{data?.firstName}} {{data?.lastName}}</span>
              <div class="user-icons">

                <span class="material-symbols-outlined ml-auto" style="cursor: pointer;"
                  (click)="naviagateToEmployeeDetails()">
                  edit
                </span>
              </div>
            </div>
            <span id="subtitle">{{data?.grade}} | {{data?.designation}}</span>
            <span id="subtitle">{{data?.employeeId}} | {{exp}} <span *ngIf="exp >= 1">+</span> Years exp.</span>
          </div>
          <div class="skills">
            <span id="inpool">In Pool</span>
            <span id="resume">Resume Uploaded &nbsp;&nbsp;<i
                [ngClass]="data.resume ? 'fas fa-check-circle mr-1 success' : 'fas fa-times-circle'"
                [ngStyle]="{'color': (data.resume) ? '#0c7c04' : '#ff0000'}"></i>
            </span>
          </div>
        </div>
      </div>


      <div class="">
        <div class="row d-flex align-items-center flex-row mt-5">
          <span class="col-4 col-md-3  competencytitle">Competency :</span>
          <span class="" *ngFor="let competency of competencyName">{{competency?.competencyName}}</span>

        </div>
        <hr>
        <div class="p-3 row d-flex flex-row">
          <span class="col-4 col-md-3 p-0 m-0 skillsets">Skillsets</span>
          <div class="d-flex p-0" *ngIf="skillList.length > 0">
            <div class="chip mr-2" *ngFor="let skillSet of skillList?.slice(0,3)">
              <i class="dot"
                [ngStyle]="{'background-color': skillSet?.proficiency==3 ? '#15A055' : ( skillSet.proficiency==2 ? '#FF7A00' : '#9DA9CA') }"></i>
              {{skillSet.skill}}
            </div>
            <div *ngIf="skillList && skillList.length > 3" [title]="getPrimaryDefaultSkills(skillList)">...</div>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-4 col-md-3">
            <span class="smetitle">SME</span>
          </div>
          <div class="px-0">
            <div class="mb-2">
              <span class="" *ngFor="let competency of competencyName">
                <span *ngFor="let subCompetency of competency.subCompetencies">
                  <span *ngFor="let sme of subCompetency.smEs">{{ sme?.smeFactory }}</span>
                </span>
              </span>
            </div>
            <div class="names d-flex ">
              <div class="first-icon">
                <span class="fas fa-check-circle techno-icon">
                </span>
                <span>
                  Customer Facing
                </span>
              </div>
              <div class="first-icon">
                <span class="fas fa-check-circle techno-icon">
                </span>
                <span>
                  RFP
                </span>
              </div>
              <div class="first-icon">
                <span class="fas fa-check-circle techno-icon">
                </span>
                <span>
                  Solutioning
                </span>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="row d-flex flex-row">
          <span class="col-3 mr-2 certification">Certifications</span>
          <span *ngFor="let competency of competencyName">
            <span *ngFor="let subCompetency of competency.subCompetencies">
              <span *ngFor="let certificate of subCompetency.certificates; let last = last">
                {{ certificate?.name }}
                <span *ngIf="!last">|</span>
              </span>
            </span>
          </span>
        </div>
        <hr>
        <div class="row d-flex flex-row display">
          <div class="col-3 mr-2 domain">Vertical</div>
          <div class="d-flex px-0 row">
            <span class="px-0" *ngFor="let domain of domains; let last = last">
              {{ domain }}
              <span *ngIf="!last">|</span>
            </span>
          </div>
          <hr>
        </div>
      </div>
    </div>
    <div class="career col-12 col-md">
      <img src="assets/images/org-chat.png" alt="grade" srcset="">
    </div>
  </div>